import { render, staticRenderFns } from "./WiringComponent.vue?vue&type=template&id=4502f6d1&scoped=true"
import script from "./WiringComponent.vue?vue&type=script&lang=js"
export * from "./WiringComponent.vue?vue&type=script&lang=js"
import style0 from "./WiringComponent.vue?vue&type=style&index=0&id=4502f6d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4502f6d1",
  null
  
)

export default component.exports